// extracted by mini-css-extract-plugin
export default {"text":"HistoryRow_text__oETUE","link":"HistoryRow_link__byP2T"};